export default {
  name: "언어",
  en: "영어",
  cn: "중국어(간체)",
  tw: "캄보디아어",
  vi: "베트남어",
  th: "태국어",
  id: "인도네시아어",
  my: "미얀마어",
  jp: "일본어",
  kr: "한국어"
};